import {Component, forwardRef, Input, OnDestroy, OnInit} from '@angular/core';
import {ControlValueAccessor, FormControl, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR} from '@angular/forms';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {WidgetValidator} from '@pt/pt-models';
import {ValidatorGenerator} from '../../utils/validator-generator';

@Component({
  selector: 'pt-input-phone',
  templateUrl: './input-phone.component.html',
  styleUrls: ['./input-phone.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => InputPhoneComponent)
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => InputPhoneComponent),
      multi: true
    }
  ]
})
export class InputPhoneComponent implements OnInit, OnDestroy, ControlValueAccessor {

  @Input() controlName: string;
  @Input() validators: WidgetValidator[];
  @Input() label: string;
  @Input() placeholder: string;
  @Input() help: string;
  @Input() error: string;    // Da implementare


  public formGroup: FormGroup;
  isRequired: boolean;
  inputId: string;
  isChanged = false;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  private onChanged: (val) => void;
  private onTouched: () => void;

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  ngOnInit(): void {
    this.inputId = 'ptWInputPhone_' + this.controlName;

    this.isRequired = ValidatorGenerator.validatorsContainsRequired(this.validators);

    this.setFormGroup();

    this.formGroup.valueChanges.pipe(
      takeUntil(this.destroy$)
    ).subscribe(t => {
      this.isChanged = t.value !== null;
      if (this.onChanged) {
        this.onChanged(t.value);
      }
      if (this.onTouched) {
        this.onTouched();
      }
    });
  }

  writeValue(obj: any): void {
    if (obj) {
      this.formGroup.controls.value.setValue(obj);
    } else {
      this.formGroup.controls.value.setValue(null);
      this.formGroup.markAsUntouched();
    }
  }

  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.formGroup.controls.value.disable();
    } else {
      this.formGroup.controls.value.enable();
    }
  }

  validate(value: FormControl) {
    return this.formGroup.invalid && {
      invalid: true
    };
  }

  private setFormGroup() {
    const validator = ValidatorGenerator.generateValidator(this.validators);
    this.formGroup = new FormGroup({
      value: new FormControl(null, validator)
    });
  }
}
